<template>
<v-container>
  <v-dialog v-model="dialog" persistent width="400" v-if="!userLoading">
    <v-card>
      <v-card-text v-if="userId" class="text-xs-center mb-0">
        <v-avatar :size="64" class="mx-2 my-2"><img :src="userAvatar"></img></v-avatar>
        <p class="subheading font-weight-bold">{{userMail}}</p>
      </v-card-text>
      <v-card-text>
        <p class="subheading">{{ $t('join.welcome',{name:$appName}) }}</p>
        <p v-if="userId" v-html="$t('join.welcome_description',{name:$appName})"></p>
        <p v-if="userId" class="text-xs-center font-weight-bold">{{clientName}}</p>
        <p v-if="!userId" v-html="$t('join.sign_in_required',{client:clientName})"></p>
        <p v-if="!userId" v-html="$t('join.workaround_google_sign_in')"></p>
      </v-card-text>
      <v-card-actions>
        <v-btn large flat @click="changeAccount" color="secondary" v-if="userId">{{ $t('join.change_account') }}</v-btn>
        <v-btn large flat @click="copy" color="secondary" v-else>{{ $t('join.copy_link') }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn large flat color="primary" v-if="userId" @click="activate" :loading="activating">{{ $t('join.join_now') }}</v-btn>
        <v-btn large flat color="primary" v-if="!userId" @click="login">{{ $t('join.sign_in') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <progress-dialog :visible="userLoading">{{ $t('loading') }}</progress-dialog>

</v-container>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'

function makeToken() {
  const c = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  return Array(48).fill('').map(t => c.charAt(Math.floor(Math.random() * c.length))).join('');
}

export default {
  name: 'Authorize',
  mixins: [UserAuth],
  data: () => ({
    authCode: null,
    dialog: true,
    activating: false
  }),
  computed: {
    clientName() {
      let clientId = this.$route.query.client_id;
      switch (clientId) {
        case 'actions':
          return 'Google';
        case 'actions-smarthome':
          return 'Google';
        case 'alexa':
          return 'Alexa';
        case 'alexa-smarthome':
          return 'Alexa Smart Home';
        case 'ifttt':
          return 'IFTTT';
      }
    }
  },
  methods: {
    login() {
      this.$router.replace('/login?redirect=' + encodeURIComponent(this.$route.fullPath));
    },
    changeAccount(){
      this.$auth.signOut();
      this.login();
    },
    redirect() {
      let q = this.$route.query;
      let href = `${decodeURIComponent(q.redirect_uri)}?state=${q.state}&code=${this.authCode}`;
      window.location.href = href;
    },
    async activate() {
      try {
        this.activating = true;
        this.authCode = makeToken();
        await this.$db.ref('userOauth2Code').child(this.userId).set({
          code: this.authCode,
          clientId: this.$route.query.client_id,
          redirectUri: decodeURIComponent(this.$route.query.redirect_uri)
        });
        this.redirect();
      } catch (err) {
        this.activating = false;
      }
    },
    async copy() {
      try {
        await this.$copyText(window.location.href);
        this.$emit('toast', this.$t('join.link_copied'));
      } catch (err) {
        console.log(err);
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/auth/Authorize.vue